<template>
    <div>
        <div class="swap-modal-align-center vrm-modal--select-device">
            <div class="vrm-modal__title">
                {{
                    $t('general.select_installation_replacement', {
                        i18nFallback: 'Select the original installation',
                    })
                }}
            </div>
        </div>
        <div class="vrm-modal__content swap-modal-align-center">
            <div class="vrm-modal__text">
                {{
                    $t(`general.confirm_replace_modal.historical`, {
                        i18nFallback:
                            'The historical data from your selected installation will be preserved. The replacement GX device will begin updating to this installation once installed.',
                    })
                }}
            </div>
        </div>

        <div class="vrm-modal__content">
            <div class="installation-selection-header replace-device-modal">
                <div
                    class="installation-selection__title"
                    v-html="
                        $t(`general.confirm_replace_modal.current_installation`, {
                            i18nFallback: 'Original Installation',
                        })
                    "
                ></div>
                <div class="arrow-space"></div>
                <div
                    class="installation-selection__title"
                    v-html="
                        $t(`general.confirm_replace_modal.replacement_installation`, {
                            i18nFallback: 'Replacement installation',
                        })
                    "
                ></div>
            </div>
            <div class="installation-selection replace-device-modal">
                <div class="pick-installation">
                    <p
                        class="installation-selection__title"
                        v-html="
                            $t(`general.confirm_replace_modal.current_installation`, {
                                i18nFallback: 'Current Installation',
                            })
                        "
                    ></p>
                    <vrm-dropdown-gx
                        :target="'currentInstallation'"
                        :installations="swapInstallationsModel.rawInstallations"
                        :model="swapInstallationsModel"
                        :placeholder="'addinstallation.select_target_gx'"
                        :fallback="'Select target GX'"
                    ></vrm-dropdown-gx>
                </div>
                <div class="arrow-container">
                    <i class="sg-vrm-icon_126_arrow-right-32px arrow"></i>
                </div>

                <div class="pick-installation">
                    <p
                        class="installation-selection__title"
                        v-html="
                            $t(`general.confirm_replace_modal.replacement_installation`, {
                                i18nFallback: 'replacement installation',
                            })
                        "
                    ></p>
                    <vrm-dropdown-gx
                        :target="'selectedInstallation'"
                        :installations="swapInstallationsModel.rawInstallations"
                        :model="swapInstallationsModel"
                        :placeholder="'addinstallation.select_replacement_gx'"
                        :fallback="'Select replacement GX'"
                    ></vrm-dropdown-gx>
                </div>
            </div>
        </div>

        <div class="vrm-modal__content swap-modal-align-center">
            <button
                class="sg-btn sg-blue"
                :disabled="
                    !swapInstallationsModel.currentInstallation ||
                        !swapInstallationsModel.selectedInstallation
                "
                @click="setWizardStep(1)"
            >
                {{
                    $t(`general.confirm_replace_modal.proceed`, {
                        i18nFallback: 'Proceed to the next step',
                    })
                }}
            </button>
        </div>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import VrmDropdownGx from '@/vue/components/shared/VrmDropdownGX';
import { ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: {
        VrmDropdownGx,
    },
    props: {
        swapInstallationsModel: {
            type: Object,
        },
    },
    methods: {
        setWizardStep(value) {
            this.$parent.setWizardStep(value);
        },
    },
})
@AngularLocaleBundle('general')
export default class VrmSwapDevicesStepSelect extends Vue {
    @ngInject()
    SwapInstallationService;
}
</script>
